import React, { useEffect } from 'react';

import PageHeader from 'components/common/general/layouts/PageHeader';
import PageFooter from 'components/common/general/layouts/PageFooter';
import { observer } from 'mobx-react-lite';
import { useOverrideQuotedRatesPageStore } from 'store/pages/override-quoted-rates/pageStore';
import { OverlaySpinner } from '@insurancemenu/imenu-components-lib/dist/components';
import { OverrideRatesSection } from './OverrideRatesSection';
import { QuotedResultsSection } from './QuotedResultsSection';
import { ContentStyled } from './styles';

export const OverrideQuotedRatesContent: React.FC = observer(() => {
  const { isLoading, canOverrideRates, returnBack, getInitialData, overrideRates } = useOverrideQuotedRatesPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <div>
      <PageHeader
        title="Override Quoted Rates"
        subtitle="Adjust your quoted rates by applying a discount or manually updating the values before submission"
        subtitleMaxWidth="53rem"
        onRedirect={returnBack}
      />
      <ContentStyled>
        {isLoading ? (
          <OverlaySpinner display />
        ) : (
          <>
            <QuotedResultsSection />
            <OverrideRatesSection />
            <PageFooter
              disableCompleteButton={!canOverrideRates}
              onBack={returnBack}
              onComplete={overrideRates}
              completeButtonText="Override Rates"
            />
          </>
        )}
      </ContentStyled>
    </div>
  );
});
